import { render } from "./Collection-Landing-Page.vue?vue&type=template&id=e18f4b7e&scoped=true"
import script from "./Collection-Landing-Page.vue?vue&type=script&lang=js"
export * from "./Collection-Landing-Page.vue?vue&type=script&lang=js"

import "./Collection-Landing-Page.vue?vue&type=style&index=0&id=e18f4b7e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e18f4b7e"]])

export default __exports__